import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButton } from '@angular/material/button';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import {
  MatNativeDateModule,
  provideNativeDateAdapter,
} from '@angular/material/core';
import {
  MatFormField,
  MatFormFieldModule,
  MatSuffix,
} from '@angular/material/form-field';
import {
  MatDatepicker,
  MatDatepickerModule,
  MatDatepickerToggle,
} from '@angular/material/datepicker';

import { TranslateModule } from '@ngx-translate/core';

import { ESvgIcons } from 'src/app/core/enums/svg-icons';
import { OccasionGeniusResponse } from 'src/app/core/types/models/occasion-genius-response.model';

import { HotelsBookingProviderService } from 'src/app/shared/used-components/hotels-booking-container/hotels-booking-provider.service';

@Component({
  selector: 'app-occasion-genius-filters-mobile',
  templateUrl: './occasion-genius-filters-mobile.component.html',
  styleUrls: ['occasion-genius-filters-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButton,
    MatRadioGroup,
    MatRadioButton,
    MatFormField,
    MatInput,
    MatSuffix,
    TranslateModule,
    MatDatepickerToggle,
    MatDatepicker,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [HotelsBookingProviderService, provideNativeDateAdapter()],
})
export class OccasionGeniusFiltersMobileComponent implements OnChanges {
  @Input() occasionGeniusResponse: OccasionGeniusResponse;
  @Input() filters: Record<string, any> = {
    from: '',
    to: '',
    score: '',
    search: '',
    categories: [],
    events: [],
  };

  @Output() onApply = new EventEmitter<{
    requestBody: Record<string, any>;
    filters: Record<string, any>;
  }>();

  public scoresOptions = [
    { label: '1-25', value: '0' },
    { label: '26-99', value: '1' },
    { label: '100-999', value: '2' },
    { label: '1,000-9,999', value: '3' },
    { label: '10,000-99,000', value: '4' },
    { label: '100,000-999,999', value: '5' },
    { label: '1,000,000+', value: '6' },
  ];

  selectedFilters: any = {
    from: '',
    to: '',
    score: '',
    search: '',
    categories: [],
  };
  protected readonly eSvgIcons = ESvgIcons;

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.filters.currentValue) {
        this.selectedFilters = this.filters;
      }
    }
  }

  applyFilters(): void {
    this.onApply.emit({
      requestBody: this.selectedFilters,
      filters: this.selectedFilters,
    });
  }

  clearFilters(): void {
    this.selectedFilters = {
      facilities: [],
      stars: [],
      score: null,
      accomondation: [],
      priceRange: {
        min: null,
        max: null,
      },
      sorting: null,
      refundable: false,
      breakfastIncluded: false,
    };
  }
}
